import React from 'react';
import { findIndex, sortBy } from 'lodash';

import {
  Modal,
  Button,
  // FormControl,
  // FormGroup,
  // ControlLabel,
  Col,
  Row,
  Well
} from 'react-bootstrap';


// import Tooltip from '../../../commonComponents/Tooltip';
import PagerUd from '../../../commonComponents/PagerUd';
// import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';

// import { FileDropAreaCt } from '../../../commonComponents/FileDropAreaCt';
// import {onFileDrop, onFileDelete} from '../../../commonComponents/onFileModify';
// import CustPopover from '../../../commonComponents/CustPopover';
// import DropDownMenu, {optsGenerator} from '../../../commonComponents/DropDownMenu';
// import treeViewGenerator from '../../../commonComponents/treeViewGenerator';
// import {getDefaultTableDataObj} from '../../../commonComponents/DataTable/DataTablePs';
import SpecDetailCt from './SpecDetailCt';
import SpecItemDetailCt from './SpecItemDetailCt';
// import KeyPartModalCt from './KeyPartModalCt';
import ProductStockModalCt from './ProductStockModalCt';

import custJqAjax from '../../../commonJS/custJqAjax';
import parentStateHandler from '../../../commonJS/parentStateHandler';


// const RequiredMark = props => <span style={{color: "red"}}>* </span>;


export default class SpecModalCt extends React.Component {
  constructor(props) {
    super(props);
    this.handlers = {
      textAreaOnChange: e => {
        const jsInp = e.currentTarget,
          id = jsInp.id,
          value = jsInp.value;

        this.setState({ [id]: value });

      },
      onChange: (selection, id, cb) => {
        // const len = selection.length;
        // switch(id) {
        //   case 'all_policy':
        //     const value = selection.value;
        //     this.setState({all_policy: value});

        //     if(value === 0 && !this.state.optsUser.length) {
        //       // 取得user清單與group清單
        //       this.handlers.loadUsersAndGroups();
        //     }

        //     break;
        //   case 'all_policy_user_id_list':
        //     const all_policy_user_id_list = [];
        //     for(let i = 0; i < len; i++) {
        //       all_policy_user_id_list.push(selection[i].value);
        //     }
        //     this.setState({all_policy_user_id_list});
        //     break;
        //   case 'all_policy_group_id_list':
        //     const all_policy_group_id_list = [];
        //     for(let i = 0; i < len; i++) {
        //       all_policy_group_id_list.push(selection[i].value);
        //     }
        //     this.setState({all_policy_group_id_list});
        //     break;
        //   default:
        // }
      },
      // saveProduct: isUpdate => {      
      //   let formData = new FormData(),
      //       id = isUpdate ? (this.props.selectedProductId || this.props.params.productId) : "",
      //       tw_data_list = `${this.state.price_tw}|${this.state.delivery_tw}|${this.state.characteristics_tw}|${this.state.appliance_tw}`,
      //       en_data_list = `${this.state.price_en}|${this.state.delivery_en}|${this.state.characteristics_en}|${this.state.appliance_en}`,
      //       cn_data_list = `${this.state.price_cn}|${this.state.delivery_cn}|${this.state.characteristics_cn}|${this.state.appliance_cn}`,
      //       ja_data_list = `${this.state.price_jp}|${this.state.delivery_jp}|${this.state.characteristics_jp}|${this.state.appliance_jp}`;

      //   formData.append('model_name', this.state.model_name);
      //   formData.append('tw_data_list', tw_data_list);
      //   formData.append('en_data_list', en_data_list);
      //   formData.append('cn_data_list', cn_data_list);
      //   formData.append('ja_data_list', ja_data_list);
      //   formData.append('all_policy', this.state.all_policy);
      //   formData.append('permission', this.state.permission);

      //   // if(this.state.all_policy === 0) {

      //   //   formData.append('user_id_list', this.state.all_policy_user_id_list.join());
      //   //   formData.append('group_id_list', this.state.all_policy_group_id_list.join());
      //   // }

      //   if(isUpdate) {
      //     formData.append('model_id', id);
      //   }

      //   custJqAjax({
      //     type: 'POST',
      //     url: `/api/W_SaleSky_ProductData_${isUpdate ? 'Update' : 'Post'}.php`,
      //     data: formData,
      //     processData: false,
      //     contentType: false,
      //     success: res => {
      //       if(!isUpdate && !this.state.filteredKeyPartsList.length) {
      //         this.handlers.updateKeyParts(data => {this.funcs.keyPartListFilter(data, []);});
      //       }



      //       this.handlers.onProductModified(res.result, isUpdate ? 'update' : 'create');

      //       const productId = res.result.id;

      //       if((this.state.categoryPath && this.state.categoryPathIds.length) || (this.state.orinPathIds && !this.state.categoryPathIds.length)) {
      //         // 前一個小括弧是新增和修改分類路徑時會成立
      //         // 有選過treeview或是新增時有傳入
      //         // this.state.categoryPathIds.length才會 > 0
      //         // 所以只有新增和修改關聯時才會成立

      //         // 後面的小括弧是刪除時會成立
      //         // 初始有路徑，儲存時無路徑，代表刪除

      //         let relationFormData = new FormData();

      //         const orinPathIdsArr = this.state.orinPathIds.split(',');

      //         if(this.state.orinPathIds && !this.state.categoryPathIds.length) {
      //           this.postOrUpdateProductRelation = 'Delete';

      //           relationFormData.append('path_id_list', orinPathIdsArr);
      //         }else {
      //           if(this.state.orinPathIds) {
      //             this.postOrUpdateProductRelation = 'Update';
      //             relationFormData.append('path_id_list_old', orinPathIdsArr);

      //           } else this.postOrUpdateProductRelation = "Post";

      //           relationFormData.append('path_id_list', this.state.categoryPathIds);
      //         }

      //         relationFormData.append('product_id', productId);

      //         const categoryPathIdsStr = this.state.categoryPathIds.join();
      //         if(this.state.orinPathIds !== categoryPathIdsStr) {
      //           // 有異動才call api
      //           // 建立分類路徑
      //           custJqAjax({
      //             type: 'POST',
      //             url: `/api/W_ServiceSky_ProductData_Relation_${this.postOrUpdateProductRelation}.php`,
      //             data: relationFormData,
      //             processData: false,
      //             contentType: false,
      //             success: res => {
      //               // 更新kmCategories，新增產品連結
      //               const categoryPathIds = this.postOrUpdateProductRelation === 'Delete' ? orinPathIdsArr : this.state.categoryPathIds;
      //               let tarObj = this.treeViewFuncs.locator(categoryPathIds),
      //                   productInd = findIndex(tarObj.product_ids_sorts, {id: productId});

      //               if(this.postOrUpdateProductRelation !== 'Delete') {
      //                 // 沒找到代表為新增或修改
      //                 tarObj.product_ids_sorts.push({id: productId, sort: '0'});

      //                 // 更新treeview的刪除鈕狀態
      //                 if(tarObj.product_ids_sorts.length === 1) {
      //                   this.props.refreshTreeView();
      //                 }

      //                 if(this.postOrUpdateProductRelation === 'Update' && this.state.orinPathIds !== categoryPathIdsStr) {

      //                   // 從舊所屬分類中清除id
      //                   let oldTarObj = this.treeViewFuncs.locator(orinPathIdsArr),
      //                       oldProductInd = findIndex(oldTarObj.product_ids_sorts, {id: productId});

      //                   oldTarObj.product_ids_sorts.splice(oldProductInd, 1);

      //                   // 變更關聯後，當原分類已無任何產品，更新刪除鈕狀態
      //                   if(oldTarObj.product_ids_sorts.length === 0) {
      //                     this.props.refreshTreeView();
      //                   }

      //                   this.props.updateProductTable(oldTarObj);

      //                 } else {
      //                   // 初次Post新增後記錄為orig
      //                   this.setState({orinPathIds: this.state.categoryPathIds.join()});
      //                 }
      //               }else if(this.postOrUpdateProductRelation === 'Delete' && productInd !== -1){

      //                 tarObj.product_ids_sorts.splice(productInd, 1);

      //                 if(tarObj.product_ids_sorts.length === 0) {

      //                   // 移除關聯後分類包含產品為0筆時更新treeview的刪除鈕狀態
      //                   this.props.refreshTreeView();
      //                 }
      //               }

      //               // productCategoies已變更，更新一下是需要的
      //                 this.props.stateHandler({states: 'kmCategories', newValues: this.props.kmCategories})

      //               // 如果變更的是作用中分類的產品，則更新table

      //               const effectedPath = this.state.categoryPathIds.length ? categoryPathIdsStr : orinPathIdsArr.join();

      //               if( effectedPath === this.props.selectedTrackIds.join()) {
      //                 this.props.updateProductTable(tarObj);
      //               }


      //               this.props.parentStateHandler({states: 'doSearchUpdate', newValues: 1});
      //             }
      //           });
      //         }
      //       }

      //       // 因為api的設計方式，上傳會覆蓋，
      //       // 指定的是product id 而非file name, 有上傳時不需做刪除特定檔的動作
      //       if(!this.uploadedFiles[0]) {
      //         // 處理update的檔案刪除動作
      //         if(isUpdate) this.fileWorker();
      //       }

      //       // 處理上傳檔案
      //       this.fileWorker(true, res.result.id);

      //       // 如果完全沒有執行檔案相關作業，會需要從這裡更新狀態
      //       if(this.filesWip < 1) {
      //         // 新增情境時routing
      //         if(!this.props.params || !this.props.params.productId) {
      //           this.props.router.replace('/salesky/km/' + productId);
      //         }
      //         this.setState({onEdit: false, editMode: 'View'});
      //       }

      //       // 更新搜尋結果
      //       this.props.parentStateHandler({states: 'doSearchUpdate', newValues: 1});
      //     }
      //   });
      // },
      // deleteProduct: () => {
      //   let formData = new FormData(),
      //       id = this.props.selectedProductId || this.props.params.productId;


      //   formData.append('model_id', id);

      //   custJqAjax({
      //     type: 'POST',
      //     url: '/api/W_SaleSky_ProductData_Delete.php',
      //     data: formData,
      //     processData: false,
      //     contentType: false,
      //     success: data => {
      //       const selectedProduct = find(this.props.productOrinData, {id});


      //       if(this.props.activeCateObj) {
      //         const tarObj = this.props.activeCateObj || this.props.kmCategories;
      //         let productInd = findIndex(tarObj.product_ids_sorts, {id});

      //         if(productInd !== -1) {
      //           tarObj.product_ids_sorts.splice(productInd, 1);

      //           if(tarObj.product_ids_sorts.length === 0) {
      //             // 移除關聯後分類包含產品為0筆時更新treeview的刪除鈕狀態
      //             this.props.refreshTreeView();
      //           }

      //           // kmCategoies已變更，更新一下是需要的
      //           this.props.stateHandler({states: 'kmCategories', newValues: this.props.kmCategories})
      //         }
      //       }

      //       this.handlers.onProductModified(selectedProduct, 'delete');
      //       this.props.closeModal({isDeletion: true});
      //       this.props.parentStateHandler({states: 'doSearchUpdate', newValues: 1});
      //     }
      //   });
      // },
      // onProductModified: (data, mode) => {
      //   // 更新productOrinData, productSortedData
      //   let productOrinData = this.props.productOrinData,
      //       productSortedData = "",
      //       newProduct = {
      //         id: data.id,
      //         name: data.model_name
      //       };


      //   if(mode === "create") {
      //     productOrinData.unshift(newProduct);
      //     if(this.props.activeCateObj) {
      //       this.props.updateProductTable(this.props.activeCateObj);
      //     }else {
      //       productSortedData = getDefaultTableDataObj(productOrinData);
      //     }
      //   } else if(mode === "update") {
      //     let updateInd = findIndex(productOrinData, {id: data.id});
      //     productOrinData[updateInd] = newProduct;
      //     if(this.props.activeCateObj) {
      //       this.props.updateProductTable(this.props.activeCateObj);
      //     }
      //   } else if(mode === "delete") {
      //     let updateInd = findIndex(productOrinData, {id: data.id});

      //     productOrinData.splice(updateInd, 1);
      //     if(this.props.activeCateObj) {
      //       this.props.updateProductTable(this.props.activeCateObj);
      //     }else {
      //       productSortedData = getDefaultTableDataObj(productOrinData);
      //     }
      //   }

      //   if(productSortedData) {
      //     this.props.stateHandler({states: ['productOrinData', 'productSortedData'], newValues: [productOrinData, productSortedData]});
      //   }else {
      //     this.props.stateHandler({states: 'productOrinData', newValues: productOrinData});
      //   }

      // },
      getValidationState: value => (value === 'default' || !value) ? 'error' : null,
      onEditClick: () => { this.setState({ onEdit: true, onCopy: false, editMode: "Edit" }) },
      onCopyClick: () => {
        this.setState({
          onCopy: true, onEdit: false, editMode: "Copy",
          selContactDisable: false,
          // clear files
          // downloadedFiles: [],
          // downloadedImgs: [],
          // downloadedPDFs: [],
          // downloadedVideos: [],
          // previewsImg: [],
          // previewsPDF: [],
          // previewsVideo: []
        });
      },
      // getKeyPartIds: (id, cb) => {
      //   // api修改後可抓完整資料
      //   // 只為了抓取part_id_list
      //   custJqAjax({
      //     type: 'GET',
      //     ajaxsWip: this.ajaxsWip,
      //     custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
      //     url: '/api/W_ServiceSky_Products_Get.php?id=' + id,
      //     success: res => {
      //       if(res.result.part_ids_sorts_name) {
      //         if(cb) cb(res.result.part_ids_sorts_name);
      //       } else {
      //         if(cb) cb([]);
      //       }
      //     }
      //   });
      // },
      // loadProductData: (id, cb, refreshImageOnly, cb1) => {
      //   custJqAjax({
      //     type: 'GET',
      //     ajaxsWip: this.ajaxsWip,
      //     custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
      //     url: '/api/W_ServiceSky_ProductData_GetAll.php?id=' + id,
      //     processData: false,
      //     contentType: false,
      //     success: res => {
      //       if(!res.result.id) return;
      //       const data = res.result,
      //             orinFiles = data.images.concat(data.pdfs).concat(data.videos);

      //       let downloadedFiles = this.fileFilter(orinFiles);

      //       if(!refreshImageOnly) {

      //         const path_id_list = data.servicesky_path_id_list[0];

      //         this.setState({
      //           // product
      //           model_name: data.model_name,
      //           categoryPathIds: path_id_list ? path_id_list.split(',') : [], // 先處理單筆歸屬的情況，後續確認後再調整
      //           orinPathIds: path_id_list || ""
      //         });

      //         if(cb) cb(path_id_list);

      //       } 

      //       // for downloaded files that uploaded before

      //       this.onFileDrop(downloadedFiles);

      //       if(cb1) cb1();
      //     }
      //   });
      // },
      rowIndexCheck: passUpdate => {
        // 預防使用者在modal重新整理，導致無selectedRowIndex，造成上一筆下一筆功能異常
        if (this.props.productId && !this.props.selectedRowIndex) {
          // 初始狀態的ind和indexMap是一樣的
          let id = this.props.productId,
            ind = findIndex(this.props.productSortedData._data, { id });
          if (!passUpdate) {
            this.props.parentStateHandler({
              states: ['selectedProductId', 'selectedRowIndex'],
              newValues: [id, ind]
            });
          }

          return ind;
        }
        return this.props.selectedRowIndex;
      },
      // updateKeyParts: cb => {
      //   custJqAjax({
      //     type: 'GET',
      //     ajaxsWip: this.ajaxsWip,
      //     custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
      //     url: '/api/W_ServiceSky_Issue_Relation_Lang_Get.php',
      //     success: res => {
      //       let arrObj = res.result;

      //       if(arrObj) {
      //         // 預排序以指定語言之name
      //         const sortedKeyParts = sortBy(arrObj, ['name_tw']);

      //         if(cb) cb(sortedKeyParts);

      //         this.props.parentStateHandler({
      //           states: 'allKeyPartsData',
      //           newValues: sortedKeyParts
      //         });
      //       }else if(cb) cb([]);
      //     }
      //   });
      // },
      // loadNewProduct: () => {
      //   // do didmount actions
      //   let productId = this.props.params.productId;

      //   this.handlers.loadProductData(productId, path_id_list => {
      //     if(path_id_list) this.treeViewFuncs.runPath(path_id_list);
      //   });


      //   // 抓取全部key parts
      //   let p1, p2; // promises

      //   if(!this.props.allKeyPartsData.length) {
      //     p1 = new Promise((resolve, reject) => {

      //       this.handlers.updateKeyParts(resolve);

      //     });

      //   }

      //   // 抓取選中產品擁有的key part ids
      //   p2 =  new Promise((resolve, reject) => {
      //     this.handlers.getKeyPartIds(productId, resolve);
      //   });

      //   // p1只有在this.props.allKeyPartsData無內容時才會成為promise
      //   Promise.all([p1, p2])
      //   .then( values => {this.funcs.keyPartsFilter(p1 ? values : [this.props.allKeyPartsData, values[1]]);})
      //   .catch(reason => {});

      // },
      onPreviousClick: () => {
        let selectedRowIndex = this.handlers.rowIndexCheck(),
          r = (selectedRowIndex - 1),
          rowIndex = r >= 0 ? r : 0;
        if (rowIndex !== selectedRowIndex) {
          // let id = this.props.productSortedData.getObjectAt(rowIndex).id;
          this.props.onRowClick("e", rowIndex, this.props.productSortedData, true);
          // this.handlers.loadProductData(id);

          // load new Product
          this.funcs.resetState(() => { this.funcs.refreshSolutionData(this.props.productId); });
        }
      },
      onNextClick: () => {
        let selectedRowIndex = this.handlers.rowIndexCheck(),
          r = (selectedRowIndex + 1),
          productSortedData = this.props.productSortedData,
          max = productSortedData.getSize(),
          rowIndex = r < max ? r : (max - 1);
        if (rowIndex !== selectedRowIndex) {
          // let id = productSortedData.getObjectAt(rowIndex).id;
          this.props.onRowClick("e", rowIndex, productSortedData, true);
          // this.handlers.loadProductData(id);

          // load new Product
          this.funcs.resetState(() => { this.funcs.refreshSolutionData(this.props.productId); });
        }

      },
      // onPopoverCloseClick: e => {
      //   document.getElementById('categoryPath').click();

      //   e.stopPropagation();
      // },
      // key part
      // onKeyPartClick: (activeKeyPartObj, activeKeyPartSort) => {
      //   if(activeKeyPartObj.id === this.state.activeKeyPartId) return;

      //   this.setState({
      //     activeKeyPartObj,
      //     activeKeyPartId: activeKeyPartObj.id,
      //     activeKeyPartName: activeKeyPartObj.name_tw,
      //     activeKeyPartChildren: activeKeyPartObj.solution_category_ids_sorts,
      //     activeKeyPartSort,
      //     issueCategories: {},
      //     issueTreeView: [],
      //     solutions: [],
      //     solutionSteps: [],
      //     solutionModMode: '',
      //     issueCategoryPathIds: [],
      //     activeSolutionId: '',
      //     activeSolutionSort: 0,
      //     activeSolution: {}
      //   });

      // },
      // onTreeEditClick: () => {
      //   this.setState({
      //     treeEditClick: !this.state.treeEditClick
      //   });
      // },
      onKeyPartModifyClick: e => {
        // const id = e.currentTarget.id;

        // switch(id) {
        //   case 'btn-key-part-create':
        //     this.setState({keyPartEditMode: 'create', showKeyPartModal: true});
        //     break;
        //   case 'btn-key-part-add-from-stock':
        //     this.setState({keyPartEditMode: 'create', showKeyPartStockModal: true});
        //     break;
        //   case 'btn-key-part-modify':
        //     this.setState({keyPartEditMode: 'edit', showKeyPartModal: true});
        //     break;
        //   default:
        // }
        this.setState({ showKeyPartStockModal: true });
      },
      // deleteKeyPart: () => {
      //   const keyPartId = this.state.activeKeyPartId;
      //   let formData = new FormData();

      //   formData.append('id', keyPartId);
      //   formData.append('path_id_list', this.props.params.productId);

      //   this.setState({
      //     activeKeyPartId: "",
      //     activeKeyPartName: "",
      //     activeKeyPartChildren: [],
      //     issuecategories: {},
      //     issueTreeView: [],
      //     solutionSteps: [],
      //     solutions: [],
      //     solutionModMode: '',
      //     issueCategoryPathIds: []
      //   });

      //   custJqAjax({
      //     type: 'POST',
      //     url: '/api/W_ServiceSky_Issue_Relation_Lang_Delete.php',
      //     data: formData,
      //     processData: false,
      //     contentType: false,
      //     success: res => {
      //       this.funcs.keyPartsListUpdater('delete', this.state.activeKeyPartObj);
      //     }
      //   });
      // },
      onSolutionClick: solution => {
        if (this.state.activeSolutionId === solution.item_id) return



        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: `/api/W_SaleSky_ProductGroupItem_Get.php?model_id=${this.props.productId}&item_id=${solution.item_id}`,
          // data: formData,
          processData: false,
          contentType: false,
          success: res => {
            this.setState({
              activeSolution: res.result, activeSolutionId: solution.item_id,
              solutionModMode: 'edit', activeSolutionSort: solution.sort
            });

            // 更新按鈕狀態
            this.funcs.solutionsUpdator(this.state.arrSolutionsObj);
          }
        });

        this.funcs.refreshStepData(solution.item_id);

      },
      onCreateSolutionClick: () => {
        this.setState({
          solutionModMode: 'create', activeSolutionId: '',
          activeSolution: {}, activeStepSort: 0,
          solutionSteps: []
        }, () => { this.funcs.solutionsUpdator(this.state.arrSolutionsObj); });
      },
      onStepClick: sort => {
        this.setState({ activeStepSort: sort, stepModMode: 'edit' }, () => {
          this.funcs.stepsUpdator(this.state.arrStepsObj);
        });

      },
      onCreateStepClick: () => {
        this.setState(
          { stepModMode: 'create', activeStepSort: this.state.solutionSteps ? (this.state.solutionSteps.length + 1) : 0 },
          () => { this.funcs.stepsUpdator(this.state.arrStepsObj); }
        );
      }
    }

    this.parentStateHandler = ({ states, newValues }) => {
      parentStateHandler({ states, newValues, parentThis: this });
    };

    this.ajaxsWip = [];

    // file crud相關 ===========
    // for file upload，不需渲染的資料不使用state，避免多餘的render check
    // this.uploadedFiles = [];

    // for downloaded files that uploaded before
    // this.onFileDrop = downloadedFiles => {
    //   onFileDrop(downloadedFiles, '', this, true);
    // };

    // this.onFileDelete = (type, fileName) => {
    //   // onFileDelete是在onFileDrop裡面會被使用，
    //   // type, fileName在裡面預設會傳入

    //   // 編輯模式下remove icon才有效
    //   let productId = "";
    //   if(this.props.params) productId = this.props.params.productId;

    //   if(this.state.editMode !== "View" || !productId) {
    //     onFileDelete(type, fileName, this, true);
    //   }else {
    //     return;
    //   }

    // };

    // // 配合api
    // this.fileFilter = orinFiles => {
    //   // 檔案預處理
    //   let name = "", dotInd = "", type = "";

    //   const downloadedFiles = orinFiles.map((item, ind) => {
    //     name = item.file_name;
    //     dotInd = name.lastIndexOf('.');
    //     type = name.slice(dotInd + 1);

    //     switch(type) {
    //       case 'jpg':
    //         item.type = 'image/jpeg';
    //         break;
    //       case 'png':
    //         item.type = 'image/png';
    //         break;
    //       case 'svg':
    //         item.type = 'image/svg+xml';
    //         break;
    //       case 'pdf':
    //         item.type = 'application/pdf';
    //         break;
    //       case 'mp4':
    //         item.type = 'video/mp4';
    //         break;
    //       default:
    //     }

    //     return item;

    //   });

    //   return downloadedFiles;
    // };

    // this.fileWorker = (isUpload, fileId) => {
    //   let fileData = new FormData(),
    //       requireField = 'file_id',
    //       apiType = 'W',
    //       apiKeyWord = 'Upload_Delete',
    //       len = this.state.deletedDownloadedFiles.length;

    //   if(isUpload) {
    //     requireField = '$_FILES';
    //     apiType = 'W';
    //     apiKeyWord = 'Upload_Post';
    //     len = this.uploadedFiles.length;
    //     fileData.append('file_id', fileId);
    //   }

    //   // api只支援一次傳一個檔，要用迴圈處理
    //   if(len > 0) {
    //     this.filesWip += len;
    //     if(!this.state.fileWorkInProgress) this.setState({fileWorkInProgress: true});

    //     fileData.append('type', 'KM');

    //     // do not make functions in a loop;
    //     let printRes = res => {
    //       this.filesWip -= 1;

    //       if(this.filesWip < 1) {
    //         // filesWip是上傳和delete共用

    //         if(this.uploadedFiles.length) {

    //           // 清除檔案上傳相關狀態
    //           this.uploadedFiles = [];
    //           this.setState({clearUploadedFileLocal: true});

    //           // 上傳檔案轉為下載狀態
    //           this.handlers.loadProductData(fileId || this.props.params.productId, '', true);

    //         }

    //         if(this.state.deletedDownloadedFiles.length) {
    //           // 清除刪除紀錄
    //           this.setState({deletedDownloadedFiles: []});
    //         }

    //         // 新增情境時routing
    //         if(!this.props.params || !this.props.params.productId) {
    //           this.props.router.replace('/salesky/km/' + fileId);
    //         }

    //         this.setState({
    //           fileWorkInProgress: false,
    //           onEdit: false,
    //           editMode: 'View'
    //         });
    //         // this.props.closeModal();
    //       }
    //     };

    //     for(let i = 0; i < len; i++) {
    //       let value = "";
    //       if(isUpload) {
    //         value = this.uploadedFiles[i];
    //       }else {
    //         // let fileName = this.state.deletedDownloadedFiles[i].file_name,
    //         //     backslashInd = fileName.lastIndexOf('/'),
    //         //     dotInd = fileName.lastIndexOf('.'),
    //         //     fileId = fileName.slice(backslashInd + 1, dotInd);
    //         // value = fileId;
    //         // km 用的是product id 而非檔名
    //         value = this.props.params.productId;
    //       }

    //       fileData.append(requireField, value);
    //       custJqAjax({
    //         type: 'POST',
    //         url: `/api/${apiType}_ServiceSky_File${apiKeyWord}.php`,
    //         data: fileData,
    //         processData: false,
    //         contentType: false,
    //         complete: printRes
    //       });
    //     }
    //   }
    // };

    // // 控制檔案上傳進度用
    // this.filesWip = 0; 

    // ======================

    // treeView funcs
    // this.treeViewFuncs = {
    //   runPath: pathIdListStr => {
    //     // productCt抓根目錄尚未完成情況下，待機
    //     if(!this.props.kmCategories.id) {
    //       this.timer = setTimeout(() => {this.treeViewFuncs.runPath(pathIdListStr);}, 500);
    //       return;
    //     }

    //     const pathIdListArr = pathIdListStr.split(','),
    //           len = pathIdListArr.length;

    //     let count = 0,
    //         parentObj = this.props.kmCategories,
    //         selectedTracks = [0],
    //         selectedTrackNames = ['所有產品'],
    //         selectedTrackIds = ['0'];

    //     const repeater = (parentObj, selectedTracks, selectedTrackNames, selectedTrackIds) => {
    //             const promise = new Promise((resolve, reject) => {
    //               this.treeViewFuncs.onTreeViewNodeClick(parentObj, selectedTracks, selectedTrackNames, selectedTrackIds, resolve);
    //             });

    //             promise.then(res => {
    //               count ++;
    //               if(count < len){
    //                 let ind = 0,
    //                     name = "";

    //                 if(count === 1) {
    //                   ind = findIndex(parentObj.product_category_ids_sorts, {id: pathIdListArr[count]});
    //                   name = parentObj.product_category_ids_sorts[ind].name_tw || 'No name';
    //                 } else {
    //                   parentObj = find(parentObj.product_category_ids_sorts, {id: pathIdListArr[count - 1]});
    //                   ind = findIndex(parentObj.product_category_ids_sorts, {id: pathIdListArr[count]});
    //                   name = parentObj.product_category_ids_sorts[ind].name_tw || 'No name';
    //                 }

    //                 selectedTracks.push(ind);
    //                 selectedTrackIds.push(pathIdListArr[count]);
    //                 selectedTrackNames.push(name);

    //                 repeater(parentObj, selectedTracks, selectedTrackNames, selectedTrackIds);
    //               }

    //               return;
    //             });
    //           };

    //     repeater(parentObj, selectedTracks, selectedTrackNames, selectedTrackIds);
    //   },
    //   removeRelation: () => {
    //     this.setState({categoryPathIds: [], categoryPath: '', collapsesState: {}, selectedTracks: []});
    //     this.treeViewFuncs.refreshTreeView();
    //   },
    //   onTreeViewNodeClick: (parentObj, selectedTracks, selectedTrackNames, selectedTrackIds, resolve) => {
    //     // 更新路徑
    //     const len = selectedTrackNames.length;
    //     let categoryPath = "";
    //     for (let i = 0; i < len; i++) {
    //       categoryPath += selectedTrackNames[i] + ' / ';
    //     }

    //     // 更新treeview
    //     const lastPos = selectedTracks.length - 1;

    //     let collapses = this.state.collapsesState,
    //         kmCategories = this.props.kmCategories,
    //         collapseKey = selectedTrackIds[lastPos];

    //     collapses[collapseKey] = resolve ? false : !collapses[collapseKey];

    //     const {productTreeView, collapsesState} = treeViewGenerator(kmCategories, collapses, this.treeViewFuncs.onTreeViewNodeClick, selectedTrackIds[lastPos], '', '', 'name_tw'),
    //           kmTreeView = productTreeView,
    //           ind = selectedTracks[lastPos];

    //     // 離開即重置的狀態由this管理
    //     this.setState({collapsesState, selectedTracks, kmTreeView, categoryPath, categoryPathIds: selectedTrackIds});

    //     // 是否抓取新資料
    //     // const tarObj = this.treeViewFuncs.locator(kmCategories, selectedTracks),
    //     const tarObj = (lastPos === 0 ? parentObj : parentObj.product_category_ids_sorts[ind]),
    //           childCategories = tarObj.product_category_ids_sorts;

    //     if(childCategories.length && !childCategories[0].product_category_ids_sorts) {
    //       let len = childCategories.length;

    //       this.categoriesWip += len;
    //       for(let i = 0; i < len; i++) {
    //         this.treeViewFuncs.loadCategoryData(childCategories, i, resolve);
    //       }

    //     } else {
    //       if(resolve) resolve('cateAjaxAllDone');
    //     }

    //   },
    //   locator: arrTrackIds => {
    //     const len = arrTrackIds.length;

    //     // 定位目標物件
    //     if(len) {
    //       let tempA = this.props.kmCategories,
    //           tempB = {};


    //       for(let i = 1; i < len; i++) {
    //         tempB = tempA;
    //         tempA = find(tempB.product_category_ids_sorts, {id: arrTrackIds[i]});
    //       }

    //       return tempA;
    //     }

    //   },
    //   dataTranslator: resData => {
    //     let nodeObj = {};

    //     // 轉譯為標準格式
    //     nodeObj.id = resData.id;
    //     nodeObj.name_tw = resData.name_tw;
    //     nodeObj.name_en = resData.name_en;
    //     nodeObj.name_cn = resData.name_cn;
    //     nodeObj.name_ja = resData.name_ja;
    //     nodeObj.product_category_ids_sorts = resData.product_category_ids_sorts;
    //     nodeObj.product_ids_sorts = resData.product_ids_sorts;
    //     nodeObj.sort = resData.sort ? parseInt(resData.sort, 10) : "";

    //     return nodeObj;
    //   },
    //   loadCategoryData: (childCategories, sort, resolve) => {
    //     const id = childCategories ? childCategories[sort].id : 0; 
    //     custJqAjax({
    //       type: 'GET',
    //       ajaxsWip: this.ajaxsWip,
    //       custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
    //       url: `/api/W_ServiceSky_ProductCategories_Lang_Get.php?id=${id}`,
    //       complete: res => {
    //         this.categoriesWip -= 1;
    //         if(this.categoriesWip < 1 && resolve) {
    //           resolve('cateAjaxAllDone');
    //         }
    //       },
    //       success: res => {
    //         let kmCategories = this.props.kmCategories,
    //             nodeObj = this.treeViewFuncs.dataTranslator(res.result);
    //             // childCategories = [];

    //         // childCategories是productCategoreis裡面的一個key參照到的arr
    //         // 所以改變此arr，連帶也會改變kmCategories的內容

    //         // 分類預排序
    //         const childCate = sortBy(nodeObj.product_category_ids_sorts, ['sort']);
    //         nodeObj.product_category_ids_sorts = childCate;

    //         if(!kmCategories.id) {
    //           kmCategories = nodeObj;
    //         }else {
    //           // childCategories = this.treeViewFuncs.locator(kmCategories, this.state.selectedTracks).product_category_ids_sorts;
    //           childCategories.splice(sort, 1, nodeObj);
    //         }



    //         const pos = this.state.categoryPathIds.length - 1,
    //               activeId = pos === -1 ? "" : this.state.categoryPathIds[pos],
    //               {productTreeView, collapsesState} = treeViewGenerator(kmCategories, this.state.collapsesState, this.treeViewFuncs.onTreeViewNodeClick, activeId, '', '', 'name_tw'),
    //               kmTreeView = productTreeView;

    //         this.setState({collapsesState, kmTreeView});

    //         this.props.stateHandler({
    //           states: 'kmCategories',
    //           newValues: kmCategories
    //         });

    //       }
    //     });
    //   },
    //   toggleTreeView: e => {
    //     e.stopPropagation();

    //     if(this.state.kmTreeView.length === 0) {
    //       const pos = this.state.categoryPathIds.length - 1,
    //             activeId = pos === -1 ? "" : this.state.categoryPathIds[pos],
    //             {productTreeView, collapsesState} = treeViewGenerator(this.props.kmCategories, this.state.collapsesState, this.treeViewFuncs.onTreeViewNodeClick, activeId, '', '', 'name_tw'),
    //             kmTreeView = productTreeView;

    //       this.setState({collapsesState, kmTreeView});
    //     }

    //     // 同一個func裡面的多個setState會整合成一次
    //     this.setState({showTreeView: !this.state.showTreeView});

    //   },
    //   refreshTreeView: () => {

    //     const {productTreeView, collapsesState} = treeViewGenerator(this.props.kmCategories, {}, this.treeViewFuncs.onTreeViewNodeClick, '', '', '', 'name_tw'),
    //           kmTreeView = productTreeView;

    //     this.setState({collapsesState, kmTreeView});

    //   }
    // }

    // funcs
    this.funcs = {
      resetState: cb => {

        this.uploadedFiles = [];

        this.setState({
          // product
          // model_name: "",
          // price_tw: "",
          // price_en: "",
          // price_cn: "",
          // price_jp: "",
          // delivery_tw: "",
          // delivery_en: "",
          // delivery_cn: "",
          // delivery_jp: "",
          // characteristics_tw: "",
          // characteristics_en: "",
          // characteristics_cn: "",
          // characteristics_jp: "",
          // appliance_tw: "",
          // appliance_en: "",
          // appliance_cn: "",
          // appliance_jp: "",
          // all_policy: 1,
          // permission: 2,
          // key parts
          // filteredKeyParts: [],
          filteredKeyPartsList: [],
          // activeKeyPartObj: {},
          // activeKeyPartId: "",
          // activeKeyPartName: "",
          // activeKeyPartSort: 0,
          // keyPartEditMode: 'view',
          // showKeyPartModal: false,
          // showKeyPartStockModal: false,
          // // issueCategories
          // issueCategories: {},
          // issueTreeView: [],
          // issueCategoryPathIds: [],
          // doIssueCategoryRefresh: false,
          // // for treeview開啟編輯鈕由外部執行
          // treeEditClick: false,
          // showTreeEdit: false,
          // solution
          solutions: [],
          arrSolutionsObj: [],
          activeSolutionId: '',
          activeSolutionSort: 0,
          activeSolution: {},
          solutionModMode: '',
          addSolution: false,
          delSolution: false,
          // solution steps
          solutionSteps: [],
          arrStepsObj: [],
          activeStepSort: 0,
          stepModMode: '',
          // for product treeView
          // orinPathIds: '', // didmount時抓取之後就不變更
          // categoryPath: '', // 分類路徑文字
          // categoryPathIds: [],
          // collapsesState: {},
          // selectedTracks: [], // [0], 關聯預設應是無作用中分類
          // kmTreeView: [],
          // showTreeView: false,
          // // file crud 相關 ====================
          // downloadedFiles: [],
          // downloadedImgs: [],
          // downloadedPDFs: [],
          // downloadedVideos: [],
          // previewsImg: [],
          // previewsPDF: [],
          // previewsVideo: [],
          // deletedDownloadedFiles: [],
          // fileWorkInProgress: false, // 控制檔案上傳進度用
          // clearUploadedFileLocal: false,
          // ====================
          // common
          btnSaveDisable: true,
          btnDeleteDisable: true,
          onEdit: false,
          onCopy: false,
          editMode: "View",
          editPermission: true
        }, cb ? cb : "");
      },
      // keyPartListFilter: (allKeyParts, filteredKeyParts) => {
      //   const filteredKeyPartsList = differenceBy(allKeyParts, filteredKeyParts, 'id');
      //   this.setState({filteredKeyPartsList});
      // },
      // keyPartsFilter: values => {
      //   if(!values[1]) return;
      //   const len = values[1].length;


      //   let tempObj;

      //   for(let i = 0; i < len; i++) {
      //     values[1][i].sort *= 1;
      //     // 取得solution_category_ids_sorts
      //     tempObj = find(values[0], {id: values[1][i].id});
      //     values[1][i].solution_category_ids_sorts = tempObj.solution_category_ids_sorts;
      //   }

      //   const filteredKeyParts = sortBy(values[1], ['sort']);

      //   // let arrObj = [];
      //   // for(let i = 0; i < len; i++) {
      //   //   let obj = find(values[0], {id: values[1][i]});
      //   //   if(obj) arrObj.push(obj);
      //   // }

      //   // const num = arrObj.length;
      //   // // 轉數字
      //   // for(let i = 0; i < num; i++) {
      //   //   arrObj[i].sort *= 1;
      //   // }

      //   // const filteredKeyParts = sortBy(arrObj, ['sort']);

      //   this.funcs.keyPartListFilter(values[0], filteredKeyParts);

      //   this.setState({filteredKeyParts});
      // },
      onSortUdpateFE: arrObj => {
        const len = arrObj.length;
        for (let i = 0; i < len; i++) {
          arrObj[i].sort = i + 1;
        }
      },
      onSortUdpateBE: (filteredKeyParts, newSort, oldSort, cb) => {
        // 最後一筆刪除後不需更新
        // 情境是filteredKeyParts更新後

        if (filteredKeyParts.length < 1) {
          if (cb) cb();
          return;
        }

        // 確保為數字
        oldSort *= 1;

        let fd = new FormData(), sortArr = [];

        const arrObj = filteredKeyParts,
          len = filteredKeyParts.length;
        // api 改好再解註
        fd.append('product_id', this.props.params.productId);
        fd.append('type', 'part');

        // 產生排序
        for (let i = 0; i < len; i++) {
          sortArr[i] = arrObj[i].id
        }

        // 
        // 未給newSort代表為刪除keypart，至此filteredKeyPart已更新，無需移除舊置，重排即可
        // if(newSort) {
        //   sortArr.splice(oldSort - 1, 1); // 移除舊位置

        //   newSort *= 1; // 確保為數字
        //   sortArr.splice(newSort - 1, 0, arrObj[oldSort - 1].id); // 移至新位置
        // }

        fd.append('id_list', sortArr);

        custJqAjax({
          type: 'POST',
          url: '/api/W_ServiceSky_Issue_Solution_Relation_Lang_Sort_Update.php',
          data: fd,
          processData: false,
          contentType: false,
          success: res => {
            if (cb) cb();
          }
        });
      },
      // keyPartsListUpdater: (mode, keyPartObj, keyPartIds) => {
      //   let allKeyPartsData = this.props.allKeyPartsData.slice(),
      //       filteredKeyParts = this.state.filteredKeyParts.slice(),
      //       indInAll, indInFiltered;

      //   if(mode !== 'create') {
      //     indInAll = findIndex(allKeyPartsData, {id: keyPartObj.id});
      //     indInFiltered = findIndex(filteredKeyParts, {id: keyPartObj.id});
      //   }

      //   switch(mode) {
      //     case 'update':
      //       let tempObj = this.state.issueCategories;
      //       //修改issue category keypart 名稱
      //       tempObj.name_tw = keyPartObj.name_tw;
      //       tempObj.name_en = keyPartObj.name_en;
      //       tempObj.name_cn = keyPartObj.name_cn;
      //       tempObj.name_ja = keyPartObj.name_ja;

      //       // 移除舊的
      //       allKeyPartsData.splice(indInAll, 1);
      //       filteredKeyParts.splice(indInFiltered, 1);
      //       // 置入新的
      //       allKeyPartsData.splice(keyPartObj.sort - 1, 0, keyPartObj);

      //       const sortedKeyParts = sortBy(allKeyPartsData, ['name_tw']);
      //       allKeyPartsData = sortedKeyParts;

      //       filteredKeyParts.splice(keyPartObj.sort - 1, 0, keyPartObj);
      //       // 更新sort
      //       // 參照型資料型態arr, obj
      //       // this.funcs.onSortUdpateFE(allKeyPartsData);
      //       this.funcs.onSortUdpateFE(filteredKeyParts);

      //       // 更新filteredKeyPartsList


      //       this.setState({issueCategories: tempObj, doIssueCategoryRefresh: true});

      //       if(this.state.activeKeyPartSort !== keyPartObj.sort) {
      //         this.funcs.onSortUdpateBE(filteredKeyParts, keyPartObj.sort, this.state.activeKeyPartSort);
      //       }

      //       break;
      //     case 'create':

      //       if(keyPartIds) {
      //         // 置入新的，從零件庫加入的情況，
      //         // 陣列id用迴圈依序從keypart清單中找到目標keypart物件後置入
      //         const len = keyPartIds.length;

      //         let keyPartNum = filteredKeyParts.length,
      //             tempArr = this.state.filteredKeyPartsList;

      //         for(let i = 0; i < len; i++) {
      //           // 從filteredKeyPartsList移除
      //           tempArr.splice(findIndex(tempArr, {id: keyPartIds[i]}), 1);


      //           keyPartNum++;
      //           // find from allKeyParts
      //           const tarKeyPart = find(allKeyPartsData, {id: keyPartIds[i]});
      //           tarKeyPart.sort = keyPartNum;

      //           filteredKeyParts.splice(tarKeyPart.sort - 1, 0, tarKeyPart);
      //         }

      //         const filteredKeyPartsList = sortBy(tempArr, ['name_tw']);

      //         this.setState({filteredKeyPartsList});
      //       }else {
      //         // 置入新的
      //         allKeyPartsData.splice(keyPartObj.sort - 1, 0, keyPartObj);
      //         const sortedKeyParts = sortBy(allKeyPartsData, ['name_tw']);
      //         allKeyPartsData = sortedKeyParts;

      //         filteredKeyParts.splice(keyPartObj.sort - 1, 0, keyPartObj);
      //       }



      //       // 從零件庫新增的情況sort會依預設往後排，不需特別更新sort，
      //       // 只有一般新增才有改變sort的可能需更新前後端
      //       if(!keyPartIds) {
      //         // 更新FE sort
      //         // this.funcs.onSortUdpateFE(allKeyPartsData);
      //         this.funcs.onSortUdpateFE(filteredKeyParts);

      //         const len = filteredKeyParts.length;
      //         if(len !== keyPartObj.sort) {
      //           this.funcs.onSortUdpateBE(filteredKeyParts, keyPartObj.sort, len);
      //         }
      //       }


      //       break;
      //     case 'delete':
      //       // 移除舊的
      //       // allKeyPartsData.splice(indInAll, 1);
      //       filteredKeyParts.splice(indInFiltered, 1);

      //       // 更新sort
      //       // this.funcs.onSortUdpateFE(allKeyPartsData);
      //       this.funcs.onSortUdpateFE(filteredKeyParts);

      //       this.funcs.onSortUdpateBE(filteredKeyParts, '', this.state.activeKeyPartSort);

      //       // 重抓keypart list
      //       this.handlers.updateKeyParts(data => {this.funcs.keyPartsFilter([data, filteredKeyParts]);});

      //       break;
      //     default:

      //   }

      //   this.setState({filteredKeyParts});

      //   if(mode !== 'delete') {
      //     this.props.parentStateHandler({states: 'allKeyPartsData', newValues: allKeyPartsData});
      //   }
      //   // this.props.parentStateHandler({states: 'allKeyPartsData', newValues: allKeyPartsData});
      // },
      refreshSolutionData: (id, cb) => {
        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: `/api/W_SaleSky_ProductGroupItem_Get.php?model_id=${id}`,
          success: res => {
            let arrObj;
            if (res.status === '204' || res.msg === 'no data found') {
              arrObj = [];
            } else {
              arrObj = sortBy(res.result.items, [o => { return o.sort * 1 }]);
            }

            if (cb) cb();

            this.funcs.solutionsUpdator(arrObj);

          }
        });
      },
      solutionsUpdator: arrSolutionsObj => {
        let solutions = arrSolutionsObj.map((item, ind) => {
          return <div key={`solution${ind}`} className='div-key-part-group-container'>
            <Button
              className={this.state.activeSolutionId === item.item_id ? 'btn-key-parts btn-key-parts-active' : 'btn-key-parts'}
              onClick={e => { this.handlers.onSolutionClick(item); }}>
              {`${ind + 1}. ${item.name_tw}`}
            </Button>
          </div>;
        });

        this.setState({ solutions, arrSolutionsObj });
      },
      refreshStepData: (solutionId, cb) => {
        // 取得steps資料
        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: `/api/W_SaleSky_ProductGroupItemSpecUnit_Get.php?model_id=${this.props.productId}&item_id=${solutionId}`,
          // data: formData,
          processData: false,
          contentType: false,
          success: res => {
            let arrStepsObj = []

            if (res.result.specs.length) {
              arrStepsObj = sortBy(res.result.specs, [o => { return o.sort * 1 }]);
            }

            this.setState({ arrStepsObj }, cb ? cb : "");

            this.funcs.stepsUpdator(arrStepsObj);

          }
        });
      },
      stepsUpdator: arrStepsObj => {
        // 產生按鈕
        let solutionSteps = arrStepsObj.map((item, ind) => {
          return <div key={`step${ind}`} className='div-key-part-group-container'>
            <Button
              className={(this.state.activeStepSort.toString() === (ind + 1).toString()) ? 'btn-key-parts btn-key-parts-active' : 'btn-key-parts'}
              onClick={e => { this.handlers.onStepClick(item.sort); }}>
              {`${ind + 1}. ${item.spec_name_tw}`}
            </Button>
          </div>;
        });

        this.setState({ solutionSteps });
      }
    };

    // 判斷product relation更新時應用何種方法
    // this.postOrUpdateProductRelation = 'Post';

    // 控制分類get api ajax完成度
    // this.categoriesWip = 0;

    // setTimeout Id
    this.timer = "";


    this.state = {
      // product
      // model_name: "",
      // price_tw: "",
      // price_en: "",
      // price_cn: "",
      // price_jp: "",
      // delivery_tw: "",
      // delivery_en: "",
      // delivery_cn: "",
      // delivery_jp: "",
      // characteristics_tw: "",
      // characteristics_en: "",
      // characteristics_cn: "",
      // characteristics_jp: "",
      // appliance_tw: "",
      // appliance_en: "",
      // appliance_cn: "",
      // appliance_jp: "",
      // all_policy: 1,
      // permission: 2,
      // key parts
      // filteredKeyParts: [],
      filteredKeyPartsList: [],
      // activeKeyPartObj: {},
      // activeKeyPartId: "",
      // activeKeyPartName: "",
      // activeKeyPartSort: 0,
      // keyPartEditMode: 'view',
      // showKeyPartModal: false,
      // showKeyPartStockModal: false,
      // // issueCategories
      // issueCategories: {},
      // issueTreeView: [],
      // issueCategoryPathIds: [],
      // doIssueCategoryRefresh: false,
      // for treeview開啟編輯鈕由外部執行
      // treeEditClick: false,
      // showTreeEdit: false,
      // solution
      solutions: [],
      arrSolutionsObj: [],
      activeSolutionId: '',
      activeSolutionSort: 0,
      activeSolution: {},
      solutionModMode: '',
      // addSolution: false,
      // delSolution: false,
      // solution steps
      solutionSteps: [],
      arrStepsObj: [],
      activeStepSort: 0,
      stepModMode: '',
      // for product treeView
      // orinPathIds: '', // didmount時抓取之後就不變更
      // categoryPath: '', // 分類路徑文字
      // categoryPathIds: [],
      // collapsesState: {},
      // selectedTracks: [], // [0], 關聯預設應是無作用中分類
      // kmTreeView: [],
      // showTreeView: false,
      // // file crud 相關 ====================
      // downloadedFiles: [],
      // downloadedImgs: [],
      // downloadedPDFs: [],
      // downloadedVideos: [],
      // previewsImg: [],
      // previewsPDF: [],
      // previewsVideo: [],
      // deletedDownloadedFiles: [],
      // fileWorkInProgress: false, // 控制檔案上傳進度用
      // clearUploadedFileLocal: false,
      // ====================
      // common
      btnSaveDisable: true,
      btnDeleteDisable: true,
      onEdit: false,
      onCopy: false,
      editMode: "View",
      editPermission: true
    }
  }


  componentDidMount() {

    this.funcs.refreshSolutionData(this.props.productId);

    // if(this.props.params && this.props.params.productId) {
    //   this.handlers.loadNewProduct();
    // } else {
    //   // document.getElementById('model_name').focus();
    //   this.setState({
    //     categoryPath: this.props.categoryPath,
    //     categoryPathIds: this.props.selectedTrackIds,
    //     selectedTracks: this.props.selectedTracks,
    //     collapsesState: this.props.collapsesState
    //   });
    // }

  }

  componentDidUpdate() {
    // 資料驗證ok才可送出
    // 基本資料
    // if(this.state.model_name === '' || (!this.state.all_policy && !this.state.all_policy_user_id_list.length && !this.state.all_policy_group_id_list.length)) {

    //   if(!this.state.btnSaveDisable) this.setState({btnSaveDisable: true});
    // } else if(this.state.btnSaveDisable) this.setState({btnSaveDisable: false});

  }

  componentWillUnmount() {
    this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
    clearTimeout(this.timer);
  }

  render() {

    let pagerUd = "";
    // deleteBtn = "",
    // saveBtn = "",
    // editable = 0,
    // modeBtns = "",
    // saveBtnText = this.state.fileWorkInProgress ? '檔案更新中...' : '儲存';

    const productId = this.props.productId;
    // else  productId = this.props.productId;

    if (this.state.editMode !== "View" || !productId) {
      // saveBtn = (
      //   <Button className='btn-next-to-title' disabled={this.state.btnSaveDisable}
      //     onClick={() => {this.handlers.saveProduct(this.state.onEdit ? 1 : 0)}}>
      //     {saveBtnText}
      //   </Button>
      // );
      // editable = 1;
    } else {
      // const permission = this.state.editPermission;
      // let tipText = "";

      // if(!permission) {
      //   if(this.props.userId !== this.state.calendarOwnerId) tipText = "Only the creater is allowed to edit.";
      // else tipText = "You are allowed to edit logs which are created today";
      // }

      // modeBtns = (
      //   <span>
      //     {/*<Button 
      //       onClick={this.handlers.onCopyClick}
      //       className='btn-next-to-title'>
      //       複製
      //     </Button>*/}
      //     <Button 
      //       disabled={!permission}
      //       onClick={this.handlers.onEditClick}
      //       className='btn-next-to-title'>
      //       編輯
      //       {permission ? "" : <Tooltip tipText={tipText} placement="left" />}
      //     </Button>
      //   </span>
      // );


      let disablePreviousBtn = false,
        disableNextBtn = false;

      if (this.props.productSortedData.getSize) {
        const selectedRowIndex = this.handlers.rowIndexCheck(true),
          max = this.props.productSortedData.getSize();

        disablePreviousBtn = (selectedRowIndex === 0);
        disableNextBtn = (selectedRowIndex === (max - 1));
      }

      pagerUd = <PagerUd style={{ position: "absolute", width: "100%", top: 15, marginTop: 0, marginBottom: 0, marginLeft: -15, fontSize: 14, padding: "1px 0" }}
        onPreviousClick={this.handlers.onPreviousClick}
        onNextClick={this.handlers.onNextClick}
        disablePreviousBtn={disablePreviousBtn}
        disableNextBtn={disableNextBtn} />;

    }

    // deleteBtn = this.state.onEdit ? 
    //               <DeleteBtnWithConfirm
    //                 className='btn-next-to-title'
    //                 onClick={this.handlers.deleteProduct}
    //                 title="確定刪除此產品?" />
    //             : "";

    // const {previewsImg, previewsPDF, previewsVideo} = this.state;
    // downloadedFilesPreview = {previewsImg, previewsPDF, previewsVideo},
    // showRemoveRelation = (this.state.categoryPath && this.props.params && this.props.params.productId),
    // showRemoveRelation = this.state.categoryPath,
    // popoverContent = <div id='popover-tree-view-container' style={{overflow: 'auto'}}>{this.state.kmTreeView}</div>;

    // key part area
    // const canDelete = (!item.solution_category_ids_sorts || !item.solution_ids_sorts || item.solution_category_ids_sorts.length || item.solution_ids_sorts.length) ? false : true;

    let productList;
    if (this.state.showKeyPartStockModal) {
      let ind = findIndex(this.props.productOrinData, { id: productId });
      // 複製出1個新array，新舊array本身不同，但裡面的物件參照是相同的
      productList = this.props.productOrinData.slice();
      // 從清單移除自身
      productList.splice(ind, 1);
    }


    return (
      <Modal
        id="modal-product-spec"
        keyboard={false}
        backdrop="static"
        show={true}
        onHide={this.props.closeModal}
        bsSize="large"
        dialogClassName='km-modal'>

        <Modal.Header>
          <Modal.Title>
            <span style={{ padding: "6px 0px", height: 34, lineHeight: '34px' }}>
              <span>
                產品規格
              </span>
            </span>
            <Button onClick={e => { this.props.closeModal(1); }} style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>關閉</Button>
            {pagerUd}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div style={{ marginTop: 5 }}>
            <Row>
              <Col sm={12}>
                <Row>
                  <Col sm={12}>
                    <div style={{ fontWeight: "bold", position: 'relative', marginBottom: 20 }}>
                      <span style={{ color: 'blue' }}>{this.props.productName}</span>
                      <div className='div-modify-btns-container' style={{ top: -4 }}>

                        <div>
                          {
                            this.state.arrSolutionsObj.length === 0 ?
                              <Button id='btn-key-part-add-from-stock' className='btn-next-to-title'
                                onClick={this.handlers.onKeyPartModifyClick}>
                                從其他產品複製規格
                              </Button>
                              : ""
                          }

                        </div>

                      </div>
                    </div>
                  </Col>
                </Row>

              </Col>

            </Row>

            <hr />

            <Row style={{ marginTop: 15 }}>
              <Col sm={3}>
                <Row>
                  <Col sm={12}>
                    <div style={{ fontWeight: "bold", position: 'relative' }}>
                      1. 規格分類
                      <div className='div-modify-btns-container'>

                        <Button id='btn-spec-item-create' className='btn-next-to-title' disabled={false}
                          onClick={this.handlers.onCreateSolutionClick}>
                          新增
                        </Button>

                      </div>
                    </div>
                  </Col>
                </Row>
                <Well style={{ minHeight: 344, maxHeight: 600, overflow: 'auto' }}>
                  {this.state.solutions}
                </Well>

              </Col>

              <SpecItemDetailCt
                solutionId={this.state.activeSolutionId}
                solutionSort={this.state.activeSolutionSort}
                activeSolution={this.state.activeSolution}
                solutionModMode={this.state.solutionModMode}
                productId={this.props.productId}
                // issuePathIds={this.state.issueCategoryPathIds}
                parentStateHandler={this.parentStateHandler}
                solutionNum={this.state.solutions.length}
                refreshSolutionData={this.funcs.refreshSolutionData}
                arrSolutionsObj={this.state.arrSolutionsObj} />

            </Row>

            <hr />

            <Row style={{ marginTop: 15 }}>
              <Col sm={3}>
                <Row>
                  <Col sm={12}>
                    <div style={{ fontWeight: "bold", position: 'relative' }}>
                      2. 規格項目
                      <div className='div-modify-btns-container'>

                        <Button id='btn-spec-create' className='btn-next-to-title' disabled={!this.state.activeSolutionId}
                          onClick={this.handlers.onCreateStepClick}>
                          新增
                        </Button>

                      </div>
                    </div>
                  </Col>
                </Row>
                <Well style={{ minHeight: 800, maxHeight: 800, overflow: 'auto', marginBottom: 15 }}>
                  {this.state.solutionSteps}
                </Well>

              </Col>

              <SpecDetailCt
                activeStepSort={this.state.activeStepSort}
                stepModMode={this.state.stepModMode}
                arrStepsObj={this.state.arrStepsObj}
                productId={this.props.productId}
                activeSolutionId={this.state.activeSolutionId}
                parentStateHandler={this.parentStateHandler}
                stepNum={this.state.solutionSteps.length}
                refreshStepData={this.funcs.refreshStepData} />

            </Row>

            {
              // this.state.showKeyPartModal ? 
              //   <KeyPartModalCt
              //     parentStateHandler={this.parentStateHandler}
              //     filteredKeyParts={this.state.filteredKeyParts}
              //     activeKeyPartObj={this.state.activeKeyPartObj}
              //     activeKeyPartSort={this.state.activeKeyPartSort}
              //     keyPartEditMode={this.state.keyPartEditMode}
              //     keyPartsListUpdater={this.funcs.keyPartsListUpdater}
              //     productId={this.props.params.productId}
              //     activeKeyPartId={this.props.activeKeyPartId} />
              // :
              //   ""
            }

            {
              this.state.showKeyPartStockModal ?
                <ProductStockModalCt
                  filteredKeyPartsList={productList}
                  parentStateHandler={this.parentStateHandler}
                  refreshSolutionData={this.funcs.refreshSolutionData}
                  productId={this.props.productId} />
                :
                ""
            }

          </div>

        </Modal.Body>
        <Modal.Footer>
          {pagerUd}
          <Button onClick={e => { this.props.closeModal(1); }} style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>關閉</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/salesky/routes/product/SpecModalCt.jsx